'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiVolumeMute = function TiVolumeMute(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.8 8.8c-0.6-0.6-1.7-0.6-2.3 0l-2.6 2.6c-0.6-1.1-1.6-1.7-2.7-1.7-0.7 0-1.5 0.3-2.2 0.8l-4.5 2.9c-1.2 0.9-3.7 1.6-5.2 1.6-2.7 0-5 2.2-5 5v3.3c0 2.1 1.3 3.9 3.1 4.6l-2.6 2.6c-0.6 0.6-0.6 1.7 0 2.3 0.3 0.4 0.8 0.5 1.2 0.5s0.9-0.1 1.2-0.5l4.2-4.2c1.2 0.3 2.4 0.8 3.1 1.3l4.5 3c0.7 0.5 1.5 0.7 2.2 0.7 1.5 0 3.1-1.1 3.1-3.6v-14.3l4.5-4.5c0.7-0.7 0.7-1.7 0-2.4z m-8 4.4c0.1 0 0.1 0 0.2-0.1 0 0.1 0 0.2 0 0.2v2.2l-3.3 3.3v-3.5l3.1-2.1z m-13.1 6.8c0-0.9 0.7-1.7 1.6-1.7 2.1 0 4.9-0.8 6.7-1.9v4.1l-4.7 4.7c-0.7-0.1-1.4-0.2-2-0.2-0.9 0-1.6-0.7-1.6-1.7v-3.3z m5.5 5.7l2.8-2.9v4.1c-0.8-0.5-1.8-0.9-2.8-1.2z m7.8 4.5c-0.1 0-0.1-0.1-0.2-0.1l-3.1-2.1v-6.8l3.3-3.4v12.2c0 0.1 0 0.1 0 0.2z' })
        )
    );
};

exports.default = TiVolumeMute;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/volume-mute.js
// module id = 3791
// module chunks = 0